import React from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { Card, CardContent } from '../components/ui/Card';
import { SEO } from '../utils/seo';
export function EvenementsPage() {
  const events = [{
    id: 'forum-etudiant',
    title: "Forum de l'étudiant de la formation et de l'emploi",
    date: '18-19 avril 2025',
    image: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=2070&auto=format&fit=crop'
  }, {
    id: 'festival-timitar',
    title: 'Festival Timitar',
    date: 'Dates à venir (2025)',
    image: 'https://images.unsplash.com/photo-1459749411175-04bf5292ceea?q=80&w=2070&auto=format&fit=crop'
  }, {
    id: 'concert-tolerance',
    title: 'Concert pour la Tolérance',
    date: 'Dates à venir (2025)',
    image: 'https://images.unsplash.com/photo-1501281668745-f7f57925c3b4?q=80&w=2070&auto=format&fit=crop'
  }, {
    id: 'souss-gastro',
    title: "Festival International des Arts Culinaires et des Étoiles de la Cuisine 'Souss Gastro'",
    date: 'Dates à venir (2025)',
    image: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?q=80&w=2070&auto=format&fit=crop'
  }, {
    id: 'fidadoc',
    title: 'Festival International du Film Documentaire (FIDADOC)',
    date: 'Novembre 2025',
    image: 'https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?q=80&w=2070&auto=format&fit=crop'
  }, {
    id: 'moussem-taroudant',
    title: 'Moussem de Sidi Ahmed ou Moussa à Taroudant',
    date: 'Dates à venir (2025)',
    image: 'https://images.unsplash.com/photo-1548013146-72479768bada?q=80&w=2076&auto=format&fit=crop'
  }];
  return <div className="min-h-screen bg-white" data-id="element-395">
      <SEO title="Événements" description="Découvrez les événements majeurs à Agadir Souss Massa : Festival Timitar, FIDADOC, Concert pour la Tolérance, Souss Gastro et plus encore" keywords="événements Agadir, Festival Timitar, FIDADOC, Souss Gastro, événements culturels Maroc" ogImage="https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=2070&auto=format&fit=crop" data-id="element-396" />
      <Navbar data-id="element-397" />

      {/* Hero */}
      <section className="bg-arih-blue py-24 md:py-32" data-id="element-398">
        <div className="container mx-auto px-4 md:px-8 text-center" data-id="element-399">
          <h1 className="text-[48px] md:text-[70px] font-semibold text-white leading-tight mb-6" data-id="element-400">
            Événements à venir
          </h1>
          <p className="text-[20px] text-white/90 leading-[32px] max-w-2xl mx-auto" data-id="element-401">
            Anticipez les incontournables : Découvrez les événements majeurs et
            vivez des expériences inoubliables à Agadir et ses environs
          </p>
        </div>
      </section>

      {/* Warning Notice */}
      <section className="bg-white py-16" data-id="element-402">
        <div className="container mx-auto px-4 md:px-8 text-center" data-id="element-403">
          <p className="text-[18px] text-arih-gray italic max-w-3xl mx-auto" data-id="element-404">
            Veuillez noter que certains événements annoncés dans l'agenda
            pourraient être annulés ou reportés à une date ultérieure.
          </p>
        </div>
      </section>

      {/* Events Grid */}
      <section className="bg-white pb-[120px] px-4 md:px-8" data-id="element-405">
        <div className="container mx-auto" data-id="element-406">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-407">
            {events.map(event => <Card key={event.id} className="bg-white rounded-xl shadow-sm overflow-hidden border-0" data-id="element-408">
                <CardContent className="p-0" data-id="element-409">
                  <img src={event.image} alt={event.title} className="w-full h-[220px] object-cover" data-id="element-410" />
                  <div className="p-5" data-id="element-411">
                    <h3 className="text-[20px] font-bold text-arih-dark leading-tight mb-3" data-id="element-412">
                      {event.title}
                    </h3>
                    <p className="text-[16px] text-arih-gray font-medium mb-4" data-id="element-413">
                      {event.date}
                    </p>
                    <a href={`/evenements/${event.id}`} className="text-arih-blue text-[16px] font-semibold hover:underline inline-flex items-center" data-id="element-414">
                      Voir plus <span className="ml-1" data-id="element-415">→</span>
                    </a>
                  </div>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </section>

      <Footer data-id="element-416" />
    </div>;
}